module.exports = __webpack_public_path__ + "ptc_momoro_K1.3224859f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_K1.jpg
// module id = GBVs
// module chunks = 0